'use client';

import { useRouter } from 'next/navigation';
import React, { useCallback } from 'react';

import { useInbound } from '@/contexts/inbound';
import { TChannelForm } from '@/types/inbound';

import FinishMessages from '../FinishMessages';

type TFinishModal = {
  show?: boolean;
  channel?: TChannelForm;
  onBackToSite?: () => void;
  nameButton?: string;
};

const FinishModal: React.FC<TFinishModal> = ({
  show = true,
  channel = 'chat',
  onBackToSite,
  nameButton,
}) => {
  const router = useRouter();
  const { attendanceStatus } = useInbound();

  if (attendanceStatus === 'scheduled') {
    channel = 'whatsapp-out-business-hours';
  }

  const handleClose = useCallback(() => {
    if (onBackToSite) {
      return onBackToSite();
    }

    if (document.referrer.split('/')[2] !== window.location.hostname) {
      return router.push('/');
    }

    return router.back();
  }, [router, onBackToSite]);

  return show ? (
    <div className="flex fixed top-0 left-0 z-20 justify-center items-center w-full h-full bg-display-900 bg-opacity-75">
      <div className="flex flex-col justify-center items-center p-24 sm:py-40 sm:px-80 w-full sm:w-auto h-full sm:h-auto bg-display-0 sm:rounded-md">
        <FinishMessages
          channel={channel}
          onClose={handleClose}
          nameButton={nameButton}
        />
      </div>
    </div>
  ) : null;
};

export default FinishModal;
